import { vec2 } from 'gl-matrix';

/**
 * Simple class to store window level values for an image
 */
export class WindowLevel {
    /**
     * 	(0028,1051) Window Width Attribute, Corresponding to DICOM attribute by default
     */
    /**
     * 	(0028,1050) Window Center Attribute, Corresponding to DICOM attribute by default
     */
    public constructor(
        public readonly window: number,
        public readonly level: number,
        private readonly minLevel = -1000,
        private readonly maxLevel = 65536
    ) {
        if (window <= 0) {
            throw new Error('Window must be greater than 0');
        }
        if (level < minLevel || level > maxLevel) {
            throw new Error(
                `Level must be between ${minLevel} and ${maxLevel}`
            );
        }
    }

    public clone(): WindowLevel {
        return new WindowLevel(this.window, this.level);
    }

    public equals(other: WindowLevel): boolean {
        return (
            this.window === other.window &&
            this.level === other.level &&
            this.minLevel === other.minLevel &&
            this.maxLevel === other.maxLevel
        );
    }

    public get asVec2(): vec2 {
        return vec2.fromValues(this.window, this.level);
    }

    private clamp(value: number, min: number, max: number): number {
        return Math.max(min, Math.min(value, max));
    }

    public add(increment: vec2): WindowLevel {
        return new WindowLevel(
            this.clamp(
                this.window + increment[0],
                1,
                this.maxLevel - this.minLevel
            ),
            this.clamp(this.level + increment[1], this.minLevel, this.maxLevel)
        );
    }
}
